import src from "IMAGE";
export default { src, width: 483, height: 408, blurWidth: 0, blurHeight: 0};
